import './assets/main.css'

import { createApp, ref } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

const cropbildtest = false;

const app = createApp(App);

const cropimage = ref();
const tabactive = ref();
const producttype = ref();
const orientation = ref();
const vorschau = ref(false);
app.config.globalProperties.$cropimage = cropimage;
app.config.globalProperties.$tabactive = tabactive;
app.config.globalProperties.$producttype = producttype;
app.config.globalProperties.$orientation = orientation;
app.config.globalProperties.$vorschau= vorschau;

app.use(i18n)
app.use(router)

app.mount('#app')
